export const loginTypeList = {
  pwd: "pwd",
  verifyCode: "verifyCode",
  QRCode: "QRCode",
};

export const roleList = ["client", "nurse", "callcenter", "doctor"];

export const medicalHistoryFormat = {
  bellyFat: "腹性肥胖",
  chestDistress: "胸闷胸痛肩背痛",
  confirmedDesease: "您是否通过医院检查，明确知道患有某种疾病？",
  coronaryHeartDisease: "冠心病或支架植入史",
  diabetes: "糖尿病",
  dizziness: "眩晕",
  familyChd: "家族冠心病",
  familyMi: "家族心梗史",
  fatigue: "神疲乏力",
  fattyLiver: "脂肪肝",
  healthProduct: "保健品/药膳",
  highBloodPressure: "高血压",
  longTimeDrug: "您是否一直坚持服药或其他治疗方法治疗该病？",
  sweat: "心悸气短自汗",
  userMedHistoryTeleNum: "电话号码",
};

export const waveOptions = [
  {
    value: "",
    label: "",
  },
  {
    value: "U",
    label: "U",
  },
  {
    value: "大L",
    label: "大L",
  },
  {
    value: "小L",
    label: "小L",
  },
  {
    value: "下降",
    label: "下降",
  },

  {
    value: "大V",
    label: "大V",
  },
  {
    value: "平V",
    label: "平V",
  },
  {
    value: "小V",
    label: "小V",
  },
  {
    value: "W",
    label: "W",
  },
  {
    value: "平W",
    label: "平W",
  },
  {
    value: "波浪",
    label: "波浪",
  },
  {
    value: "M",
    label: "M",
  },
  {
    value: "N",
    label: "N",
  },

  {
    value: "上升",
    label: "上升",
  },
  {
    value: "平",
    label: "平",
  },
  {
    value: "倒V",
    label: "倒V",
  },
  {
    value: "倒U",
    label: "倒U",
  },

  {
    value: "平+V",
    label: "平+V",
  },

  {
    value: "平+W",
    label: "平+W",
  },

  {
    value: "平+W+平",
    label: "平+W+平",
  },
];

export const emcOptions = [
  {
    value: "",
    label: "",
  },
  {
    value: "X",
    label: "X",
  },
  {
    value: "B",
    label: "B",
  },
  {
    value: "K",
    label: "K",
  },
  {
    value: "S",
    label: "S",
  },
];

export const restWaveOptions = [
  {
    value: "",
    label: "",
  },
  {
    value: "前低后高",
    label: "前低后高",
  },
  {
    value: "前高后低",
    label: "前高后低",
  },
  {
    value: "双峰型",
    label: "双峰型",
  },
  {
    value: "波浪型（多峰型）",
    label: "波浪型（多峰型）",
  }
];

export const razIndex = [
  {
    value: "",
    label: "",
  },
  {
    value: "<3%",
    label: "<3%",
  },
  {
    value: "3%~8%",
    label: "3%~8%",
  },
  {
    value: "8%~15%",
    label: "8%~15%",
  },
  {
    value: ">15%",
    label: ">15%",
  }
];

export const unifiedPagination = {
  pageNum: 1,
  pageSize: 10,
  totalNumber: 0,
  totalPage: 1,
  currentPage: 1,
  pageSizeList: [10, 20, 50],
};

export const ExamStatesValue = {
  NOT_BOOKED_0: 0,
  BOOKED_10: 10,
  BOOK_CONFIRM_15: 15,
  ARRIVAL_20: 20,
  BASIC_QUERY_30: 30,
  BASIC_CHECK_40: 40,
  EMC_50: 50,
  ECG_60: 60,
  HYPERQ_70: 70,
  HYPERQ_REST_75: 75,
  FEED_BACK_80: 80,
  FINISHED: 90,
};

export const ExamStatesLabel = {
  NOT_BOOKED_0: "未预约",
  BOOKED_10: "已预约",
  BOOK_CONFIRM_15: "预约已确认",
  ARRIVAL_20: "已到达",
  BASIC_QUERY_30: "基础问询完成",
  BASIC_CHECK_40: "基础检查完成",
  EMC_50: "EMC检查完成",
  ECG_60: "心电检查完成",
  HYPERQ_70: "HyperQ检查完成",
  FEED_BACK_80: "检查完成",
  FINISHED: "结束",
};

export const formatSplitToArray = function(obj, keyName) {
  obj[keyName] = obj[keyName].split("^");
};

export const formatSplitToRange = function(obj, keyName) {
  obj[keyName] = obj[keyName].split("^").join("-");
};

export const Personalities = {
  A:
    "脾气比较火爆、有闯劲、遇事容易急躁、不善克制、喜欢竞争、好斗、竞争性与好胜心强；思维敏捷，爱显示自己才华；对人常存戒心，有变动不定的敌意；过分抱负和雄心壮志，过重的工作要求，对工作成就不满足；常有时间紧迫感与匆忙感；习惯做艰苦紧张的工作。难以松弛，不耐烦；进行多种思维和动作，言语节奏快；运动、走路和吃饭的节奏很快，总是试图做两件以上的事情；他们着迷于数字，似乎功是以每件事情中自己获益多少来衡量的。",
  B:
    "与A型性格相对应的性格。他们从来不曾有时间上的紧迫感以及其他类似的不适感；认为没有必要表现或讨论自己的成就和业绩，除非环境要求如此，因此总是比较低调；他们会充分享受娱乐和休闲时光，而不是不惜一切代价表现自己的最佳业绩水平；他们不会因为充分放松而不感到愧疚。",
  C:
    "这类人内心冲突大，情绪压抑，抑制烦恼，委曲求全，逆来顺受，但内心却又极不服气。这类人常常给人以不急不躁的印象，日常生活和工作中能与人保持表面和谐，但是其内心却悲观失望，矛盾而痛苦。如果这种矛盾情绪经常出现，就可能破坏人体免疫功能，导致癌症的发生。",
};
